import { Component, OnInit } from '@angular/core';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/service/notification.service';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from '../table/Buttons';
import { TableColumn } from '../table/TableColumn';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { UserManagementService } from 'src/app/service/user-management.service';
import { CalendarService } from 'src/app/service/calendar.service';
import { CalendarModel } from 'src/app/models/config/calendar.model';

@Component({
  selector: 'app-impersonate-user',
  templateUrl: './impersonate-user.component.html',
  styleUrls: ['./impersonate-user.component.css']
})
export class ImpersonateUserComponent implements OnInit {
  userData: AddUser[] = [];
  uprofileData: AddUser[] = [];
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  fileName: string = '';
  selectedUser: AddUser[] = [];
  columnsData: any;
  ordersTableColumns: TableColumn[];
  buttons: Buttons[];
  isImpersonate: boolean = false;
  imPersonUser: string = '';
  actionButtons: any;
  userModel = new AddUser();
  userModel1 = new AddUser();

  comPlansUserData: AddUser[] = [];
  salesChnlsUserData: AddUser[] = [];
  salesChannels: string[] = [];
  commPlansData: string[] = [];
  userTypes: string[] = [];
  commPlans: string[] = [];
  salesRepTypes: string[] = [];
  payrollCalender: string[] = [];
  calData: CalendarModel[];

  constructor(private manageUserService: ManageUserService, private httpService: HttpClient,
    private notificationService: NotificationService, private router: Router, private calendarService: CalendarService,
    private authGaurdService: AuthGaurdService, private userManagementService: UserManagementService,
    private exportExcelService: ExportExcelService
  ) { }

  ngOnInit(): void {
    this.initializeColumns();
    this.getPrePopulatedUserData();
    //this.getProfiles();
    //this.userSearch();
  }

  profileSearch() {
    console.log("first_name = " + this.userModel.first_name);
    let status = 0;
    if (this.userModel.first_name) {
      console.log("Inside first_name");
      status = 1;
    } else if (this.userModel.last_name) {
      console.log("Inside last_name");
      status = 1;
    } else if (this.userModel.employeeId) {
      console.log("Inside employeeId");
      status = 1;
    } else if (this.userModel.sales_rep_id) {
      console.log("Inside sales_rep_id");
      status = 1;
    } else if (this.userModel.id) {
      console.log("Inside id");
      status = 1;
    } else if (this.userModel.supervisor_id) {
      console.log("Inside supervisor_id");
      status = 1;
    } else if (this.userModel.user_type) {
      console.log("Inside user_type");
      status = 1;
    } else if (this.userModel.sales_rep_channel) {
      console.log("Inside sales_rep_channel");
      status = 1;
    } else if (this.userModel.comm_plan_id) {
      console.log("Inside comm_plan_id");
      status = 1;
    } else if (this.userModel.payroll_start_date) {
      console.log("Inside payroll_start_date");
      status = 1;
    } else if (this.userModel.soft_termination_date) {
      console.log("Inside soft_termination_date");
      status = 1;
    } else {
      status = 0;
    }
    console.log("status = " + status);
    if (status == 0) {
      this.uprofileData = [];
      this.notificationService.sendNotification(NotificationType.ERROR, "Please enter one or more search criteria");
    } else {
      this.getProfiles("complete");
    }
  }

  getProfiles(profilestatus: string) {

    this.userModel1 = null;
    this.userModel1 = JSON.parse(JSON.stringify(this.userModel));
    //console.log(this.userModel1.first_name);
    if (this.userModel1.first_name) {
    } else {
      this.userModel1.first_name = "NA";
    }

    if (this.userModel1.last_name) {
    } else {
      this.userModel1.last_name = "NA";
    }

    if (this.userModel1.employeeId) {
    } else {
      this.userModel1.employeeId = "NA";
    }

    if (this.userModel1.sales_rep_id) {
    } else {
      this.userModel1.sales_rep_id = "NA";
    }

    if (this.userModel1.user_type) {
    } else {
      this.userModel1.user_type = "NA";
    }

    if (this.userModel1.id) {
    } else {
      this.userModel1.id = "NA";
    }

    if (this.userModel1.supervisor_id) {
    } else {
      this.userModel1.supervisor_id = 0;
    }

    if (this.userModel1.comm_plan_id) {
    } else {
      this.userModel1.comm_plan_id = 0;
    }

    if (this.userModel1.sales_rep_channel) {
    } else {
      this.userModel1.sales_rep_channel = "NA";
    }

    if (this.userModel1.soft_termination_date) {
    } else {
      this.userModel1.soft_termination_date = null;
    }

    this.manageUserService.getUsers(profilestatus, this.userModel1.first_name, this.userModel1.last_name, this.userModel1.employeeId, this.userModel1.sales_rep_id, this.userModel1.soft_termination_date,this.userModel1.id, this.userModel1.supervisor_id, this.userModel1.user_type, this.userModel1.sales_rep_channel, this.userModel1.comm_plan_id, this.userModel1.payroll_start_date,'IMPERSONATE')
      .subscribe((data: AddUser[]) => {
        this.uprofileData = data;
        console.log(this.uprofileData);
        this.uprofileData.forEach((user: any, index: any) => {
          if (user.userRole == 'ADMIN') this.uprofileData.splice(index, 1);
        });
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }



  findFavMenus() {
    this.userManagementService.getFavMenus(this.selectedUser[0].employeeId)
      .subscribe((data: UserManagementModel[]) => {
        this.userManagementService.favMenuData = data;
        this.getMenuList(this.selectedUser[0].userRole);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getMenuList(userRole: string) {
    console.log('n/w id ', userRole);
    this.userManagementService.getMenuListByRole(userRole)
      .subscribe((data: UserManagementModel[]) => {
        console.log('data ', data);
        this.userManagementService.menuSubMenuData = data;
        this.authGaurdService.isImpersonate = true;

        this.authGaurdService.imPersonUser = this.selectedUser[0].first_name + " " + this.selectedUser[0].last_name;
        this.notificationService.notify(NotificationType.SUCCESS, "You are impersonate with " + this.authGaurdService.imPersonUser);
        localStorage.setItem('name', this.authGaurdService.imPersonUser);
        window.location.reload();
        this.router.navigate(['/'])
          .then(() => {
            window.location.reload();
          });
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }


  public exportExcel(): void {
    this.exportExcelService.exportFromJsonRows(this.userData, this.fileName || 'ImpersonateUsers');
  }

  update(user: any, values: any) {
    console.log("Update called");
    // Order = order.row;
    this.selectedUser = [];
    if (values.value.currentTarget.checked) {
      // user.row.edit =true;
      this.selectedUser.push(user.row);

    } else {
      this.selectedUser.forEach((value: any, index: any) => {
        if (value.employeeId == user.row.employeeId) this.selectedUser.splice(index, 1);
      });
      // user.row.edit =false;
    }
    console.log('value ', this.selectedUser);
    if (this.selectedUser.length === 1) {
      console.log('value ', this.selectedUser[0].userRole);
    }
    if (this.selectedUser.length === 1) {
      localStorage.setItem('IMPERSON_ROLE_SESSION', JSON.stringify(this.selectedUser[0].userRole));
      this.manageUserService.selectedUserModel = this.selectedUser[0];
    }
  }

  redirect(url: string) {
    console.log(url);
    if (url === 'home')
      this.router.navigate(['/']);
    else if (this.selectedUser.length === 1) {
      this.findFavMenus();
      this.manageUserService.loginUserData = this.selectedUser[0];
      localStorage.setItem('loginUserObj', JSON.stringify(this.manageUserService.loginUserData));
    }
    else {
      this.notificationService.notify(NotificationType.ERROR, "Please select only one user");
    }
  }

  actionOnButton(action: any) {
    if (action === "Impersonate") {
      if (this.selectedUser.length === 1) {
        this.findFavMenus();
        this.manageUserService.loginUserData = this.selectedUser[0];
        localStorage.setItem('loginUserObj', JSON.stringify(this.manageUserService.loginUserData));
        localStorage.setItem('IMPERSON_SCEMPID_SESSION', this.selectedUser[0].id);
        console.log('Impersonate scempid: ', localStorage.getItem('IMPERSON_SCEMPID_SESSION'));
        console.log('Impersonate employeeId: ', this.selectedUser[0].employeeId);
        this.authGaurdService.loggedInEmployeeId = this.selectedUser[0].employeeId;
        localStorage.setItem('imperloggedInEmployeeId', this.authGaurdService.loggedInEmployeeId);
      }
      else {
        this.notificationService.notify(NotificationType.ERROR, "Please select only one user");
      }
    }
  }



  getPrePopulatedUserData() {
    this.manageUserService.getPrePopulatedUserData().subscribe((data: any) => {

      this.userData = data;
      console.log(this.userData);
      for (let userInfo of this.userData) {
        if (userInfo.sales_rep_channel != null) {
          this.salesChnlsUserData.push(userInfo);
          this.salesChannels.push(userInfo.sales_rep_channel);
          if (this.salesChannels.length > 1) {
            this.salesChannels.sort((a, b) =>
              a.localeCompare(b));
          }
        } else if (userInfo.user_type != null) {
          this.userTypes.push(userInfo.user_type)
          if (this.userTypes.length > 1) {
            this.userTypes.sort((a, b) =>
              a.localeCompare(b));
          }
        } else if (userInfo.commission_plan != null) {
          this.comPlansUserData.push(userInfo);
        } else if (userInfo.sales_rep_type != null) {
          this.salesRepTypes.push(userInfo.sales_rep_type);
          if (this.salesRepTypes.length > 1) {
            this.salesRepTypes.sort((a, b) =>
              a.localeCompare(b));
          }

        } else if (userInfo.calendar_type != null) {
          this.payrollCalender.push(userInfo.calendar_type);
          if (this.payrollCalender.length > 1) {
            this.payrollCalender.sort((a, b) =>
              a.localeCompare(b));
          }
        }
      }
      //console.log("userdata===", JSON.stringify(this.comPlansUserData), " user type ", this.userTypes);
      this.manageUserService.salesChnlsUserData = this.salesChnlsUserData;
      this.manageUserService.userTypes = this.userTypes;
      this.manageUserService.comPlansUserData = this.comPlansUserData;
      this.manageUserService.salesRepTypes = this.salesRepTypes;
      this.manageUserService.payrollCalender = this.payrollCalender;
      // this.filterUserTypes();
      // this.filterSalesChannels();
      // this.filterCommStr();
      this.getCalData();
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  getCalData() {
    this.calendarService.getCalData().subscribe(
      (response: CalendarModel[]) => {
        this.calData = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.ImpersonateUsers;
        console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );



    this.actionButtons = [
      {
        name: 'Impersonate',
        class: 'btn btn-success btn-xs'
      }
    ]

  }
}